import React, {Component} from 'react';
import {Form, Control, Errors} from 'react-redux-form';
import { isRequired, required } from "../field_validations";
import { toInt } from "../parsers";
import _ from "lodash";
import Rating from 'react-rating';

class GoalEditForm extends Component {
	render() {
		const { goals, activities, entities, axis, lines, modalities, status } = this.props;
		let goalsFilter = _.filter(axis.list, {status_id: 1});
		let linesFilter = _.filter(lines.list, {status_id: 1});
		return (
			<div className="columns is-centered">
				<div className="column is-10-desktop">
					<Form model="goals.edit" onSubmit={(goals) => this._submitForm(goals)} onSubmitFailed={(error) => {this.props.setSystemNotification('¡Oh no!', 'Hay errores en el formulario', 'danger'); console.log('error', error)}}>
						<div className="field">
							<div className="control">
								<label htmlFor="name" className="label">Nombre de la Meta <span className="small has-text-danger">*</span></label>
								<Control.textarea model=".name" id="name" className="textarea" placeholder="Nombre de la Meta" errors={{isRequired}} validateOn="change"/>
								<Errors model=".name" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'El nombre es obligatorio'}} />
							</div>
						</div>

						<div className="field is-grouped">
							<div className="control">
								<label htmlFor="type" className="label">Tipo de meta <span className="small has-text-danger">*</span></label>
								<div className="select">
									<Control.select model=".type" id="type" errors={{required}} validateOn="change">
										<option value="" defaultValue>--- Tipo de meta ---</option>
										<option value="RI">Rumbo a la Igualdad</option>
										<option value="MT">Meta Tipo</option>
										<option value="MI">Meta IMEF</option>
									</Control.select>
								</div>
								<Errors model=".type" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'Debes seleccionar el tipo de meta '}} />
							</div>

							<div className="control">
								<label htmlFor="modality_id" className="label">Modalidad <span className="small has-text-danger">*</span></label>
								<div className="select" >
									<Control.select model=".modality_id" id="modality_id" parser={ toInt } changeAction={(model, value) => {this.props.change(model, value); this.props.reset('goals.edit.activities');}} errors={{required}} validateOn="change">
										<option value=" " defaultValue>--- Modalidad ---</option>
										{_.map(modalities.list,(option, k) => {
											return <option value={option.id} key={k}>{option.name}</option>
										})}
									</Control.select>
								</div>
								<Errors model=".modality_id" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'Debes seleccionar una modalidad.' }} />
							</div>

							<div className={`control`}>
								<label htmlFor="agenciable_id" className="label">Estado </label>
								<div className={`select`}>
									<Control.select
										model=".agenciable_id"
										id="agenciable_id"
										parser={toInt}
									>
										<option value="" defaultValue>--- Estado ---</option>
										{_.map(entities.list,(option, key) => {
											return <option key={key} value={option.id}>{option.name}</option>
										})}
									</Control.select>
								</div>
								<Errors
									model=".agenciable_id"
									show="touched"
									wrapper={(props) => <small className="help has-text-danger">{props.children}</small>}
									messages={{required: 'El estado es obligatorio'}}
								/>
							</div>

							<div className="control">
								<label htmlFor="status" className="label">Estatus <span className="small has-text-danger">*</span></label>
								<div className="select">
									<Control.select model=".status_id" id="status" className="select" validateOn="change">
										<option value="" defaultValue>--- Estatus ---</option>
										{_.map(status.data, (stat, k) => {
											return <option value={stat.id} key={k}>{stat.name}</option>
										})}
									</Control.select>
								</div>
								<Errors model=".status_id" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'El estatus es obligatorio'}} />
							</div>
						</div>

						<div className="field">
							<div className="control">
								<label htmlFor="goal_document" className="label">Documento Meta </label>
								<Control.text model=".goal_document" id="goal_document" className="input" placeholder="Documento Meta"/>
							</div>
						</div>

						<div className="field">
							<div className="control">
								<label htmlFor="axis_id" className="label">Eje temático <span className="small has-text-danger">*</span></label>
								<div className="select">
									<Control.select model=".axis_id" id="axis_id" errors={{required}} validateOn="change">
										<option value=" " defaultValue>--- Eje temático ---</option>
										{_.map(goalsFilter, (option, key) => {
											return <option key={key} value={option.id}>{option.name}</option>
										})}
									</Control.select>
								</div>
								<Errors model=".axis_id" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'Debes seleccionar un eje temático. '}} />
							</div>
						</div>

						<div className="field">
							<div className="control">
								<label htmlFor="line_id" className="label">Líneas de Acción <span className="small has-text-danger">*</span></label>
								<div className="select">
									<Control.select model=".line_id" id="line_id" errors={{required}} validateOn="change">
										<option value=" " defaultValue>--- Líneas de Acción ---</option>
										
										{
										_.map(linesFilter,(option, key) => {
											return <option key={key} value={option.id}>{option.code+' '+((option.name.length>100) ? option.name.substring(0, 100)+'...' : option.name)}</option>
										})}
									</Control.select>
								</div>
								<Errors model=".line_id" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'Debes seleccionar una línea de acción. '}} />
							</div>
						</div>

						<div className="field is-grouped">
							<div className="control">
								<div className="message is-inm-purple">
									<div className="message-body">
										<div className="field">
											<div className="control">
												<label htmlFor="requires_employees" className="checkbox">
													<Control.checkbox model=".requires_employees" id="requires_employees" isToggle={true}/>
													<span style={{whiteSpace:'normal'}}> Requiere contratar personas </span>
												</label>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div className="control">
								<div className="message is-inm-purple">
									<div className="message-body">
										<div className="field">
											<div className="control">
												<label htmlFor="mandatory" className="checkbox">
													<Control.checkbox model=".mandatory" id="mandatory" isToggle={true} changeAction={(model, value) => this._handleChangeMandatory(model,value,goals.edit.activities)}/>
													<span style={{whiteSpace:'normal'}}> Obligatorio </span>
												</label>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						{goals.edit.modality_id ?
							<div className="hero is-light">
								<div className="hero-body">
									<h5 className="title is-5">Listado de Actividades de la Meta <span className="small has-text-danger">*</span></h5>

									{_.map(_.filter(activities.list,{modalities:[{id:_.toInteger(goals.edit.modality_id)}]}),(item, key) => {
										return (
											<div key={key}>
												<div className="box" style={{cursor: 'pointer', backgroundColor: '#a864a9'}} onClick={() => {this._showGroup(item.id)}} >
													<div className="level">
														<div className="level-left">
															<div className="level-item">
																<div>
																	<p className="subtitle is-7"
																	   style={{color: '#fff', paddingBottom: '25px'}}>Grupo</p>
																	<p className="title is-6" style={{color: '#fff'}}>{item.name}</p>
																</div>
															</div>
														</div>
														<div className="level-right">
															<div className="level-item">
																<span className="icon" style={{color: '#fff'}}>
																	{this.state.groupId === item.id && this.state.showGroup ?
																		<i className="fa fa-angle-up"/>
																		: <i className="fa fa-angle-down"/>}
																</span>
															</div>
														</div>
													</div>
												</div>
												{this.state.groupId === item.id && this.state.showGroup ?
													<table className="table is-fullwidth project-goal-table no-margin">
														<thead>
														<tr>
															<th>Agregar</th>
															<th>Actividad</th>
															{goals.edit.mandatory ?
																<th>Obligatorio</th> :null}
														</tr>
														</thead>
														<tbody>
														{_.map(item.activities, (row,k) => {
															let initial = _.findKey(goals.edit.activities, {id:row.id}) !== undefined ? 1 : 0;
															let initialMandatory = undefined;
															if(goals.edit.mandatory){
																initialMandatory = _.findKey(goals.edit.activities, {id:row.id, mandatory: true}) !== undefined ? 1 : 0;
															}
															return (
																<tr key={k}>
																	<td className="goal-cell" style={{width:10+'%'}}>
																		<div className="control has-text-centered" onClick={() => this._addActivity(row.id)}>
																			<Rating ref={`activity-${row.id}`}
																			        id={`activity-${row.id}`}
																			        initialRating={initial}
																			        start={0} stop={1} step={1}
																			        emptySymbol="fa fa-square-o fa-2x"
																			        fullSymbol="fa fa-check-square-o fa-2x"
																			        className="has-text-white"/>
																		</div>
																	</td>
																	<td>
																		<label htmlFor={`activity-${row.id}`}>{row.name}</label>
																	</td >
																	{(goals.edit.mandatory ?
																		<td style={{width:15+'%'}}>
																			{initial ?
																				<div className="control has-text-centered" onClick={() => this._addMandatory(row.id)}>
																					<Rating ref={`mandatory-${row.id}`}
																					        id={`mandatory-${row.id}`}
																					        initialRating={initialMandatory}
																					        start={0} stop={1} step={1}
																					        emptySymbol="fa fa-square-o fa-2x"
																					        fullSymbol="fa fa-check-square-o fa-2x"
																					        className="has-text-inm-purple"/>
																				</div> :''}
																		</td>:null)}
																</tr>
															)
														})}
														</tbody>
													</table>
													:''}
											</div>
										)
									})}


								</div>
							</div> :''}

						<div className="field is-grouped is-grouped-right">
							<div className="control">
								<button type="button" className="button is-large" onClick={() => this.props.history.push('/proigualdad/metas')}>
									Regresar
								</button>
							</div>
							<div className="control">
								<Control.button model="goals.edit" className="button is-large is-inm-purple" type="submit" disabled={this._validateSave()}>
									Guardar
								</Control.button>
							</div>
						</div>

						<p className="has-text-grey has-text-right is-small">Los campos indicados con <span className="small has-text-danger">*</span> son obligatorios.</p>
					</Form>
				</div>
			</div>
		)
	}

	constructor(){
		super();
		this.state= {
			groupId: undefined,
			showGroup: false
		}
	}

	_showGroup(id) {
		if (id !== this.state.groupId) {
			this.setState({
				groupId: id,
				showGroup: true
			})
		} else {
			this.setState({
				groupId: undefined,
				showGroup: false
			})
		}
	}

	_submitForm(values) {
		this.props.goalSave(values);
	}

	_handleChangeMandatory(model,value,activities){
		this.props.change(model,value);
		if(!_.isEmpty(activities)){
			_.map(activities,(item, key) => {
				return this.props.change(`goals.edit.activities[${key}].mandatory`,false);
			})
		}
	}

	_addActivity(activityId){
		let {activities} = this.props.goals.edit;

		let activityIndex = _.findIndex(activities, {id: activityId});
		if(this.refs[`activity-${activityId}`].state.value === 0){
			if(activityIndex === -1){
				this.props.add(`goals.edit.activities`,{
					id: activityId
				})
			}else {
				this.props.change(`goals.edit.activities[${activityIndex}]`,{
					id: activityId
				})
			}
		}else{
			if(activityIndex !== -1){
				this.props.remove(`goals.edit.activities`,activityIndex)
			}
		}
	}

	_addMandatory(activityId){
		let {activities} = this.props.goals.edit;

		let activityIndex = _.findIndex(activities, {id: activityId});
		if(this.refs[`mandatory-${activityId}`].state.value === 0){
			this.props.change(`goals.edit.activities[${activityIndex}].mandatory`,true);
		}else{
			this.props.change(`goals.edit.activities[${activityIndex}].mandatory`,false);
		}
	}

	_validateSave(){
		const {goals} = this.props;
		let gc = _.find(goals.permissions, (o) => {return o==='Create'});
		let gu = _.find(goals.permissions, (o) => {return o==='Update'});

		if(!_.isEmpty(goals.edit) && goals.edit.id){
			if(gu){
				return false;
			}else {
				return true;
			}
		}else if(!_.isEmpty(goals.edit) && _.isEmpty(goals.edit.id)){
			if(gc){
				return false;
			}else {
				return true;
			}
		}else {
			return true;
		}
	}
}

export default GoalEditForm;


// WEBPACK FOOTER //
// ./src/elements/goals/form.jsx